"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _MuiCollapse = _interopRequireDefault(require("./components/MuiCollapse/MuiCollapse"));

var _MuiGrow = _interopRequireDefault(require("./components/MuiGrow/MuiGrow"));

var _MuiFade = _interopRequireDefault(require("./components/MuiFade/MuiFade"));

var _MuiZoom = _interopRequireDefault(require("./components/MuiZoom/MuiZoom"));

var _MuiSlide = _interopRequireDefault(require("./components/MuiSlide/MuiSlide"));

var _customProps = require("../../utils/customProps");

var _customComponents = require("../../utils/customComponents");

var MuiTransitions = function MuiTransitions(_ref) {
  var content = _ref.content,
      rootClass = _ref.rootClass;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var components = {
    MuiCollapse: _MuiCollapse.default,
    MuiFade: _MuiFade.default,
    MuiGrow: _MuiGrow.default,
    MuiZoom: _MuiZoom.default,
    MuiSlide: _MuiSlide.default
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.root
  }, content.map(function (component, key) {
    return (0, _customComponents.renderComponents)(components, component, key);
  }));
};

var _default = MuiTransitions;
exports.default = _default;
MuiTransitions.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Content passed to render
   * components:
   * MuiCollapse,
   * MuiFade,
   * MuiGrow,
   * MuiZoom,
   * MuiSlide,
   */
  content: function content(props, propName, componentName) {
    var validComponents = ['MuiCollapse', 'MuiFade', 'MuiGrow', 'MuiZoom', 'MuiSlide'];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, validComponents, 1);
  }
};
MuiTransitions.defaultProps = {
  rootClass: [],
  content: []
};